package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.ImageOutline: ImageVector
    get() {
        if (_imageOutline != null) {
            return _imageOutline!!
        }
        _imageOutline = Builder(name = "ImageOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 10.0f, viewportHeight = 10.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(1.0545f, 9.9166f)
                curveTo(0.7598f, 9.9166f, 0.5104f, 9.8145f, 0.3062f, 9.6104f)
                curveTo(0.1021f, 9.4062f, 0.0f, 9.1568f, 0.0f, 8.8622f)
                verticalLineTo(1.0545f)
                curveTo(0.0f, 0.7598f, 0.1021f, 0.5104f, 0.3062f, 0.3062f)
                curveTo(0.5104f, 0.1021f, 0.7598f, 0.0f, 1.0545f, 0.0f)
                horizontalLineTo(8.8622f)
                curveTo(9.1568f, 0.0f, 9.4062f, 0.1021f, 9.6104f, 0.3062f)
                curveTo(9.8145f, 0.5104f, 9.9166f, 0.7598f, 9.9166f, 1.0545f)
                verticalLineTo(8.8622f)
                curveTo(9.9166f, 9.1568f, 9.8145f, 9.4062f, 9.6104f, 9.6104f)
                curveTo(9.4062f, 9.8145f, 9.1568f, 9.9166f, 8.8622f, 9.9166f)
                horizontalLineTo(1.0545f)
                verticalLineTo(9.9166f)
                moveTo(1.0545f, 9.0416f)
                horizontalLineTo(8.8622f)
                curveTo(8.907f, 9.0416f, 8.9482f, 9.023f, 8.9855f, 8.9855f)
                curveTo(9.023f, 8.9482f, 9.0416f, 8.907f, 9.0416f, 8.8622f)
                verticalLineTo(1.0545f)
                curveTo(9.0416f, 1.0096f, 9.023f, 0.9685f, 8.9855f, 0.9311f)
                curveTo(8.9482f, 0.8937f, 8.907f, 0.875f, 8.8622f, 0.875f)
                horizontalLineTo(1.0545f)
                curveTo(1.0096f, 0.875f, 0.9685f, 0.8937f, 0.9311f, 0.9311f)
                curveTo(0.8937f, 0.9685f, 0.875f, 1.0096f, 0.875f, 1.0545f)
                verticalLineTo(8.8622f)
                curveTo(0.875f, 8.907f, 0.8937f, 8.9482f, 0.9311f, 8.9855f)
                curveTo(0.9685f, 9.023f, 1.0096f, 9.0416f, 1.0545f, 9.0416f)
                verticalLineTo(9.0416f)
                moveTo(1.8958f, 7.7291f)
                horizontalLineTo(8.0656f)
                lineTo(6.1474f, 5.1715f)
                lineTo(4.5096f, 7.3029f)
                lineTo(3.3429f, 5.8109f)
                lineTo(1.8958f, 7.7291f)
                verticalLineTo(7.7291f)
                moveTo(0.875f, 9.0416f)
                curveTo(0.875f, 9.0416f, 0.875f, 9.023f, 0.875f, 8.9855f)
                curveTo(0.875f, 8.9482f, 0.875f, 8.907f, 0.875f, 8.8622f)
                verticalLineTo(1.0545f)
                curveTo(0.875f, 1.0096f, 0.875f, 0.9685f, 0.875f, 0.9311f)
                curveTo(0.875f, 0.8937f, 0.875f, 0.875f, 0.875f, 0.875f)
                verticalLineTo(0.875f)
                curveTo(0.875f, 0.875f, 0.875f, 0.8937f, 0.875f, 0.9311f)
                curveTo(0.875f, 0.9685f, 0.875f, 1.0096f, 0.875f, 1.0545f)
                verticalLineTo(8.8622f)
                curveTo(0.875f, 8.907f, 0.875f, 8.9482f, 0.875f, 8.9855f)
                curveTo(0.875f, 9.023f, 0.875f, 9.0416f, 0.875f, 9.0416f)
                verticalLineTo(9.0416f)
                verticalLineTo(9.0416f)
            }
        }
        .build()
        return _imageOutline!!
    }

private var _imageOutline: ImageVector? = null
